import React, { memo } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export const GuaranteeSection = memo(function GuaranteeSection() {
  return <section className="py-16 px-4 bg-white border-t border-gray-200" data-id="element-78">
      <div className="max-w-xl mx-auto text-center" data-id="element-79">
        {/* Icon */}
        <div className="inline-flex items-center justify-center p-4 bg-green-50 rounded-full mb-6 border border-green-200" data-id="element-80">
          <ShieldCheckIcon className="w-10 h-10 text-green-600" data-id="element-81" />
        </div>

        {/* Headline */}
        <h2 className="text-[24px] md:text-3xl font-black text-gray-900 leading-tight mb-4" data-id="element-82">
          Probalo sin riesgo.{' '}
          <span className="text-green-600" data-id="element-83">El riesgo lo bancamos nosotros.</span>
        </h2>

        {/* Card */}
        <div className="bg-green-50/50 border border-green-200 rounded-2xl p-6 text-left mb-6 shadow-sm" data-id="element-84">
          <p className="text-gray-600 text-[14px] md:text-base leading-relaxed mb-5 text-center" data-id="element-85">
            Tenés{' '}
            <strong className="text-gray-900" data-id="element-86">30 días completos</strong> para
            recorrer el Megapack. Si sentís que no valió la pena,{' '}
            <strong className="text-gray-900" data-id="element-87">
              te devolvemos el 100% de tu plata.
            </strong>{' '}
            Sin formularios. Sin excusas. Sin vueltas.
          </p>

          <div className="grid grid-cols-2 gap-3" data-id="element-88">
            {[{
            icon: '✅',
            text: '30 días de garantía'
          }, {
            icon: '✅',
            text: '100% de devolución'
          }, {
            icon: '✅',
            text: 'Sin preguntas'
          }, {
            icon: '✅',
            text: 'Respuesta en 48hs'
          }].map((item, i) => <div key={i} className="flex items-center gap-2 text-[13px] text-gray-600" data-id="element-89">
                <span data-id="element-90">{item.icon}</span>
                <span data-id="element-91">{item.text}</span>
              </div>)}
          </div>

          <div className="mt-5 pt-4 border-t border-green-200 text-center" data-id="element-92">
            <p className="text-gray-500 text-[12px]" data-id="element-93">
              Soporte:{' '}
              <strong className="text-blue-600" data-id="element-94">
                construyeprogresoo@gmail.com
              </strong>
            </p>
          </div>
        </div>

        {/* Cierre */}
        <p className="text-gray-500 text-[14px] md:text-base" data-id="element-95">
          Seguir pagando técnicos, seguir con un sueldo que no alcanza, seguir sin un oficio.{' '}
          <strong className="text-gray-900" data-id="element-96">
            Ese es el único riesgo real que existe acá.
          </strong>
        </p>
      </div>
    </section>;
});